import Planck from "./libs/planck";
import type * as PlanckType from "planck";

export default Planck as unknown as typeof PlanckType;
export type * from "planck";